document.addEventListener("DOMContentLoaded", () => {
	const targets = document.querySelectorAll(".js-fadeTrigger");

	const options = {
		root: null,
		rootMargin: "-70% 0px -30% 0px",
		threshold: 0,
	};

	const observer = new IntersectionObserver((entries, obs) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add("is-inview");
				obs.unobserve(entry.target);
			}
		});
	}, options);

	// 読み込み時点で画面内にある要素を判定して即is-inviewを付ける
	function checkInitialVisibility(el) {
		const rect = el.getBoundingClientRect();
		const vh = window.innerHeight;

		// ★通り過ぎている（rect.bottom < 0）
		if (rect.bottom < 0) {
			return true;
		}

		// ★すでに画面内に入っている（top < vh）
		if (rect.top < vh) {
			return true;
		}

		return false;
	}

	// まず読み込み時点で可視判定
	targets.forEach((el) => {
		const visible = checkInitialVisibility(el);

		if (visible) {
			el.classList.add("is-inview");
		} else {
			observer.observe(el);
		}
	});
});
